import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text } from '@primer/react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
  This component is not available in production yet however multiple teams are currently contributing to this.
    </Note>
    <h2>{`Overview`}</h2>
    <p>{`An input that provides suggestions through qualifiers and highlights complex filter syntax.`}</p>
    <h2>{`Anatomy`}</h2>
    <img width="960" alt="The filter input annotated with specific naming for individual items. The input has a 'label:bug state:open assignee:' value and shows multiple suggestions for users." src="https://user-images.githubusercontent.com/980622/207303787-02ef7089-d3c5-4135-bdca-d83eccd032f4.png" />
    <h2>{`Content`}</h2>
    <h3>{`Icon`}</h3>
    <p>{`A filter input allows free form text searching as well as using qualifiers to narrow down your search.
The filter input always supports free form text search. This is why you should use the search icon as a leading visual. A filter icon could give the impression that free form text search isn't available.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/204516414-4e6e00ba-38f7-49e5-8a80-9e3bc91ccd97.png" role="presentation" width="456" alt="An input that has a magnifying glass icon on the left side." />
    <Caption mdxType="Caption">Use the search icon in a filter input.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/204516427-75b0a18d-9f61-4541-931c-ba0e8175fa07.png" role="presentation" width="456" alt="An input that has a filter icon on the left side which consists of 3 lines getting incrementally smaller." />
    <Caption mdxType="Caption">Don't use a filter icon in a filter input.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Submit`}</h3>
    <p>{`There are two ways this component can trigger submission of the input value.`}</p>
    <ol>
      <li parentName="ol">{`Auto update results as the value changes (recommended)`}</li>
      <li parentName="ol">{`Provide a search button next to the filter input`}</li>
    </ol>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/208663121-13da38c6-a38a-4b83-b8a0-ae72fd6ca803.png" role="presentation" width="456" alt="A focused filter input with value 'label:bug state:open abc' indicating that when it should instantly filter results on the page and debounce this if using API calls." />
    <Caption mdxType="Caption">Auto update results based on when the input value changes.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/208663115-a8ed1b8e-e2f9-4ce4-9fdd-7ffaa639e447.png" role="presentation" width="456" alt="A focused filter input with value 'label:bug state:open abc' suggesting a `Submit/Start search` item." />
    <Caption mdxType="Caption">Don't add an item to submit the current value.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Clear button`}</h3>
    <p>{`The clear button only appears when there is at least one character entered in the input. When the input is empty the clear button disappears again.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/204872106-ff9e6eb7-dc9a-421a-a82e-4a3df9115795.png" role="presentation" width="456" alt="An input without a value." />
    <Caption mdxType="Caption">Hide the clear button when the input is empty.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/204872101-33720780-4f9a-4141-bffc-4d008dde755e.png" role="presentation" width="456" alt="An input without a value showing a clear button on the right." />
    <Caption mdxType="Caption">Don't show the clear button when the input is empty.</Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use an icon instead of a link for clearing the input. This avoids confusion with the value of the input. Especially when the input has a long value that gets close to the clear button a link could be problematic.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/206299392-9399c13b-ee1c-4bc9-9c9c-d177fb76a06b.png" role="presentation" width="456" alt="An input with a value must shows a clear button on the right." />
    <Caption mdxType="Caption">Use a circular clear button with an x icon to clear the input.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/206299390-808585c6-8d78-4dc6-949b-7aa20cccc4c4.png" role="presentation" width="456" alt="An input without a value incorrectly showing a 'clear' link on the right." />
    <Caption mdxType="Caption">Don't use a link for clearing as this could be confused with the text inside the input.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Avoid duplication`}</h3>
    <p>{`When introducing custom qualifiers it's important to avoid repetitive icons or descriptions to increase readability and reduce noise for screen readers.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/208691915-5bc8d7a7-c706-42a9-a7db-b80d25696ca6.png" role="presentation" width="456" alt="An input with a value 'pinned:' suggesting 'Application', 'Form submissions', 'Performance', 'Feature requests', 'Large data sets' and 'Issues'. None of the items has an icon or additional descriptions." />
    <Caption mdxType="Caption">
      An input with a value 'pinned:' suggesting 'Application', 'Form submissions', 'Performance', 'Feature requests',
      'Large data sets' and 'Issues'. All items include a pin board icon and a `Pinned` description.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/208691913-0d95c706-13fe-4ef9-b730-7a70c9991fcb.png" role="presentation" width="456" alt="An input without a value incorrectly showing a 'clear' link on the right." />
    <Caption mdxType="Caption">Don't repeat icons or descriptions that add no additional value.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Sorting`}</h3>
    <p>{`There are two different states that should be considered when providing suggestions:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Default`}</strong>{`: You've entered a matching qualifier and get default suggestions. For example: `}<inlineCode parentName="li">{`author:`}</inlineCode>{`.`}</li>
      <li parentName="ol"><strong parentName="li">{`Narrow down`}</strong>{`: You've entered a value after your qualifier to narrow down the suggestions. For example: `}<inlineCode parentName="li">{`author:max`}</inlineCode></li>
    </ol>
    <img src="https://user-images.githubusercontent.com/980622/207305358-37b63ef8-f85a-4616-8c1c-9bc8b077b42f.png" role="presentation" width="960" alt="Two examples of the filter input. One has the value `author:` and is suggesting a few users to pick from. The other one has the value `author:max` and is suggesting a few users with `max` in their name or username." />
    <p>{`We should always strive to provide as relevant results as possible when dealing with `}<inlineCode parentName="p">{`user`}</inlineCode>{`, `}<inlineCode parentName="p">{`organization`}</inlineCode>{`, `}<inlineCode parentName="p">{`repository`}</inlineCode>{`, `}<inlineCode parentName="p">{`issue`}</inlineCode>{`, `}<inlineCode parentName="p">{`pull request`}</inlineCode>{` items. This can be done through a mix of considerations:`}</p>
    <ol>
      <li parentName="ol">{`Objects you've interacted with`}</li>
      <li parentName="ol">{`Organizations you're part of and it's members`}</li>
      <li parentName="ol">{`Repositories you're part of and it's members`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Approximate_string_matching"
        }}>{`Approximate string matching`}</a>{` (fuzzy)`}</li>
    </ol>
    <p>{`Let's take the `}<inlineCode parentName="p">{`author:`}</inlineCode>{` as an example. While in the `}<inlineCode parentName="p">{`default`}</inlineCode>{` state we aren't searching through the authors and want to provide a default list with users.
It's crucial we make the suggestions as relevant as possible therefore we rank them based on how often/recently you've interacted with them.`}</p>
    <p>{`Once we start narrowing down those results by using `}<inlineCode parentName="p">{`author:max`}</inlineCode>{` we enter the `}<inlineCode parentName="p">{`narrow down`}</inlineCode>{` state and apply `}<em parentName="p">{`approximate string matching`}</em>{` on those suggestions. In this case we still rank users that I've recently interacted with or that are part of my organization/repositories higher.`}</p>
    <p>{`Not all our infrastructure supports this logic yet. If not available we fall back on alphabetical ordering.`}</p>
    <p>{`For static items that only return a handful of suggestions we often can just order items through common sense:`}</p>
    <img src="https://user-images.githubusercontent.com/980622/207307327-b31cef7a-39cc-4d18-a801-033746d710ef.png" role="presentation" width="960" alt="Two example of qualifiers that return static data. The 'created' qualifier suggests: 'Today', 'This week', 'This month', 'Oct 19, 2007', 'Before June 4, 2018' and 'After June 4, 2018'. The 'stars' qualifier suggests: 'More than 10', 'Less than 10', 'Between 10 and 100' and '100'" />
    <h2>{`Qualifiers`}</h2>
    <p>{`The filter input comes with a list of predefined qualifiers and prestyled suggestions. This ensures everyone aligns on the same qualifiers as well as on the styling of suggestions.`}</p>
    <img src="https://user-images.githubusercontent.com/980622/207306454-20315d1b-74c3-4188-a854-5c62bb955886.png" role="presentation" alt="Multiple examples of qualifiers and the suggestions they provide. Qualifiers 'language', 'author' and 'state' are used as examples." width="960" />
    <p>{`Even though custom qualifiers can be added it's important to check if your new qualifier could fit in one of the predefined qualifiers below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Icon`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Qualifier`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Origin`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Suggestions`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Format`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Preview`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/person-16"
            }}>{`person`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`assignee`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatar`}</inlineCode>{`, `}<inlineCode parentName="td">{`username`}</inlineCode>{` and `}<inlineCode parentName="td">{`Full Name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`username`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335821-6dcb45dc-1b79-4270-8a78-825acadce8f0.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/person-16"
            }}>{`person`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`author`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatar`}</inlineCode>{`, `}<inlineCode parentName="td">{`username`}</inlineCode>{` and `}<inlineCode parentName="td">{`Full Name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`username`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335836-1f7766cd-acc6-41c5-921e-9764357d2589.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/calendar-16"
            }}>{`calendar`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`created`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Today`}</inlineCode>{`, `}<inlineCode parentName="td">{`Yesterday`}</inlineCode>{`, `}<inlineCode parentName="td">{`Last 7 days`}</inlineCode>{`, `}<inlineCode parentName="td">{`Last 30 days`}</inlineCode>{`, `}<inlineCode parentName="td">{`Oct 19, 2007`}</inlineCode>{`, `}<inlineCode parentName="td">{`Before June 4, 2018`}</inlineCode>{`, `}<inlineCode parentName="td">{`After June 4, 2018`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`@today`}</inlineCode>{`, `}<inlineCode parentName="td">{`@today-1d`}</inlineCode>{`,`}<inlineCode parentName="td">{`@today-1w`}</inlineCode>{`,`}<inlineCode parentName="td">{`>@today-1m`}</inlineCode>{`, `}<inlineCode parentName="td">{`>YYYY-MM-DD`}</inlineCode>{`, `}<inlineCode parentName="td">{`YYYY-MM-DD`}</inlineCode>{`, `}<inlineCode parentName="td">{`YYYY-MM-DD..YYYY-MM-DD`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335851-a5f464cc-2e70-4050-8e48-82f71c837389.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/repo-forked-16"
            }}>{`repo-forked`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`fork`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Yes`}</inlineCode>{`, `}<inlineCode parentName="td">{`No`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{`, `}<inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335873-2f6e8519-c2cf-41fb-8560-572c2ee660e2.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/apps-16"
            }}>{`apps`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`is`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Action`}</inlineCode>{`, `}<inlineCode parentName="td">{`Code`}</inlineCode>{`, `}<inlineCode parentName="td">{`Command`}</inlineCode>{`, `}<inlineCode parentName="td">{`Commit`}</inlineCode>{`...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335878-9877e103-c235-4e03-a306-12cbc4e77f35.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/tag-16"
            }}>{`tag`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Title`}</inlineCode>{`, `}<inlineCode parentName="td">{`Description`}</inlineCode>{` and `}<inlineCode parentName="td">{`color`}</inlineCode>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335883-08f7a9ba-5529-4486-9c24-da8debf562b2.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/code-16"
            }}>{`code`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`language`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`C`}</inlineCode>{`, `}<inlineCode parentName="td">{`C##`}</inlineCode>{`, `}<inlineCode parentName="td">{`C++`}</inlineCode>{`, `}<inlineCode parentName="td">{`CoffeeScript`}</inlineCode>{`...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`language`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335891-e63e53e9-b30c-4636-91d2-b9eba239a223.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/globe-16"
            }}>{`globe`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`location`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Amsterdam, Netherlands`}</inlineCode>{`, `}<inlineCode parentName="td">{`Bern, Switzerland`}</inlineCode>{`...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"Amsterdam, Netherlands"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335903-928f9bc7-4772-4166-8a83-8d62a60ff48f.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/file-badge-16"
            }}>{`file-badge`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`license`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`BSD Zero Clause License`}</inlineCode>{`, `}<inlineCode parentName="td">{`Academic Free License v3.0`}</inlineCode>{`...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cc0-1.0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335897-9311c884-0c66-4d10-81b0-a7111405444b.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/mention-16"
            }}>{`mention`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`mentions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatar`}</inlineCode>{`, `}<inlineCode parentName="td">{`username`}</inlineCode>{` and `}<inlineCode parentName="td">{`Full Name`}</inlineCode>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`username`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335907-b58c2ae4-59bf-4594-abca-c85f838b1f3d.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/organization-16"
            }}>{`organization`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`org`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatar`}</inlineCode>{`, `}<inlineCode parentName="td">{`username`}</inlineCode>{` and `}<inlineCode parentName="td">{`Full Name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`username`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335912-324815e0-eed5-492d-ad69-e070e6d2ffb7.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/repo-16"
            }}>{`repo`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`repo`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatar`}</inlineCode>{`, `}<inlineCode parentName="td">{`username/repo-name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`username/repo-name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335923-f63517ed-eda2-4ed8-a434-7ff25a123d54.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/file-directory-16"
            }}>{`file-directory`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`path`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`path`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`path`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335918-83e9b028-e7f5-48e1-99b0-b68ac7c12d85.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/issue-draft-16"
            }}>{`issue-draft`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`state`}</inlineCode>{` (generic)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode>{`, `}<inlineCode parentName="td">{`merged`}</inlineCode>{`, `}<inlineCode parentName="td">{`closed`}</inlineCode>{`, `}<inlineCode parentName="td">{`draft`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335939-ec2d1c4c-e564-4509-93ca-a4ba05b5c167.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/git-pull-request-draft-16"
            }}>{`git-pull-request-draft`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`state`}</inlineCode>{` (pr)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode>{`, `}<inlineCode parentName="td">{`merged`}</inlineCode>{`, `}<inlineCode parentName="td">{`closed`}</inlineCode>{`, `}<inlineCode parentName="td">{`draft`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335949-e65f3708-65eb-4087-a8f4-c657a0bcd5d6.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/issue-draft-16"
            }}>{`issue-draft`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`state`}</inlineCode>{` (issue)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode>{`, `}<inlineCode parentName="td">{`closed`}</inlineCode>{`, `}<inlineCode parentName="td">{`draft`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`open`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335944-80089848-ffc4-4fbc-8d6b-ed7b00d11fab.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/comment-discussion-16"
            }}>{`comment-discussion`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`comments`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`More than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Less than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Between 10 and 100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode>{`,`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`>100`}</inlineCode>{`, `}<inlineCode parentName="td">{`10..100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335844-4b89c9db-1add-4b39-951d-5bee28c2b2d6.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/people-16"
            }}>{`people`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`followers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`More than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Less than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Between 10 and 100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`>100`}</inlineCode>{`, `}<inlineCode parentName="td">{`10..100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335866-81c6cfc6-e619-4624-8fbd-f09d92373b0a.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/star-16"
            }}>{`star`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`stars`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`More than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Less than 10`}</inlineCode>{`, `}<inlineCode parentName="td">{`Between 10 and 100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`>100`}</inlineCode>{`, `}<inlineCode parentName="td">{`10..100`}</inlineCode>{`, `}<inlineCode parentName="td">{`100`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335933-795de5c6-8bb6-414a-bf83-4e34aaa08972.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/calendar-16"
            }}>{`calendar`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`updated`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Today`}</inlineCode>{`, `}<inlineCode parentName="td">{`Yesterday`}</inlineCode>{`, `}<inlineCode parentName="td">{`Last 7 days`}</inlineCode>{`, `}<inlineCode parentName="td">{`Last 30 days`}</inlineCode>{`, `}<inlineCode parentName="td">{`Oct 19, 2007`}</inlineCode>{`, `}<inlineCode parentName="td">{`Before June 4, 2018`}</inlineCode>{`, `}<inlineCode parentName="td">{`After June 4, 2018`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`@today`}</inlineCode>{`, `}<inlineCode parentName="td">{`@today-1d`}</inlineCode>{`,`}<inlineCode parentName="td">{`@today-1w`}</inlineCode>{`,`}<inlineCode parentName="td">{`>@today-1m`}</inlineCode>{`, `}<inlineCode parentName="td">{`>YYYY-MM-DD`}</inlineCode>{`, `}<inlineCode parentName="td">{`YYYY-MM-DD`}</inlineCode>{`, `}<inlineCode parentName="td">{`YYYY-MM-DD..YYYY-MM-DD`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335954-d669b842-5437-47d3-8589-a3ed67b834c4.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/file-code-16"
            }}>{`file-code`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`extension`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`static`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`md, Markdown`}</inlineCode>{`, `}<inlineCode parentName="td">{`json, JavaScript Object Notation`}</inlineCode>{`...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`md`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207335860-7237c64b-f159-4c25-9591-0bbaae7dde51.png"
            }}>{`View`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/people-16"
            }}>{`people`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`team`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`avatars`}</inlineCode>{`, `}<inlineCode parentName="td">{`name`}</inlineCode>{` and `}<inlineCode parentName="td">{`total members`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://user-images.githubusercontent.com/980622/207593729-5f39a33f-277a-4329-bfc1-d75f63bba34e.png"
            }}>{`View`}</a></td>
        </tr>
      </tbody>
    </table>
    <p>{`⚠️ This list will change a lot over the next month to accomodate different teams.`}</p>
    <h3>{`Generics`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`state:`}</inlineCode>{` qualifier has multiple variants to improve the experience for specific items:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`state`}</inlineCode>{`: For both pull requests and issues (no icons)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`state-pr`}</inlineCode>{`: For only pull requests (with icons)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`state-issue`}</inlineCode>{`: For only issues (with icons)`}</li>
    </ul>
    <p>{`Therefore it's important to use the correct qualifier as soon as you can determine if you're filtering to pull requests or issues.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/207307872-9c518626-32f4-46cf-afc8-7b0518fe5e6a.png" role="presentation" width="456" alt="An input with value 'is:pr state:' showing suggestions with colored icons: 'Open', 'Merged', 'Closed' and 'Draft'" />
    <Caption mdxType="Caption">Use the `state-pr` variant when filtering pull requests.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/207307868-b3d78303-3ba0-4d3d-ade4-dd893d9065a7.png" role="presentation" width="456" alt="An input with value 'is:pr state:' showing suggestions without icons: 'Open', 'Merged', 'Closed' and 'Draft'" />
    <Caption mdxType="Caption">Don't use the `state` variant when filtering pull requests.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Highlighting`}</h3>
    <p>{`If invalid values are used we don't show highlighting.`}</p>
    <p>{`While this applies to all qualifiers we do understand that for the ones that depend on our api endpoints (`}<inlineCode parentName="p">{`users`}</inlineCode>{`, `}<inlineCode parentName="p">{`repositories`}</inlineCode>{`, `}<inlineCode parentName="p">{`organisations`}</inlineCode>{`...) we can't always accurately match every result and therefore while not ideal we always highlight those. For example when not single signed-on to a organisation some repositories might not be returned.
Also consider that users might copy paste strings containing qualifiers. In this case you need to run through every qualifier to set the highlight if needed.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/205069299-569989df-e6b7-410f-bcf6-5106774887a0.png" role="presentation" width="456" alt="An input with the value 'is:bananas' where 'bananas' isn't highlighted." />
    <Caption mdxType="Caption">Remove highlighting on values when they are invalid.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/205069297-b9e03b40-0d52-4079-966d-e6d089440ab6.png" role="presentation" width="456" alt="An input with the value 'is:bananas' where 'bananas' is highlighted." />
    <Caption mdxType="Caption">Don't show highlighting on invalid values.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`No matches`}</h3>
    <p>{`When no matches are found we stop suggesting items through the popover and don't show anything.
In rare cases the user could be searching for `}<inlineCode parentName="p">{`format:format`}</inlineCode>{` within the content of items they are filtering to and this will still allow them to do so.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/207312763-f4b5c848-cb18-4172-8e25-35a510c1e1b7.png" role="presentation" width="456" alt="An input with the value 'author:username-not-found'" />
    <Caption mdxType="Caption">Stop suggesting if no matches are found.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/207312759-97e6a6ce-5fa3-4a6f-bd23-a7f0d98f754d.png" role="presentation" width="456" alt="An input with the value 'author:username-not-found' and a suggestion showing 'Not found, try a different username'" />
    <Caption mdxType="Caption">Don't show an empty state when no matches are found.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Values with spaces`}</h3>
    <p>{`Some qualifiers like `}<inlineCode parentName="p">{`location:`}</inlineCode>{` might have values which contain spaces. eg: 'Amsterdam, Netherlands'. In this case we encapsulate the value between straight quotes (not smart quotes).`}</p>
    <p>{`Without this it would be hard for the parser to understand where the value ends.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/205074856-ae4b1b8b-7276-4d6d-8177-baa465241b30.png" role="presentation" width="456" alt="An input with the value `location:'Amsterdam, Netherlands'` using straight quotes around the location value." />
    <Caption mdxType="Caption">Use straight quotes around values with spaces.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/205074852-1b3376d9-aee1-4ba3-994b-84305604e0bf.png" role="presentation" alt="An input with the value 'location:Amsterdam, Netherlands' without using quotes around the location value. This is invalid." width="456" />
    <Caption mdxType="Caption">Don't use values with spaces without quotes.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Deprecate where possible`}</h3>
    <p>{`There are many qualifiers on our platform that could be unified or deleted. For example `}<inlineCode parentName="p">{`type:`}</inlineCode>{` can now be replaced by `}<inlineCode parentName="p">{`is:`}</inlineCode>{`.
Remember that deprecating means that we stop suggesting those options to users but we still keep them available in the backend until we see usage declining to low volumes.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/207309519-affaf0ce-ab7d-471f-a52c-7c59242045e8.png" role="presentation" alt="An input with the value 'is:' suggesting options: 'Issue' and 'Pull request'. The options also include icons." width="456" />
    <Caption mdxType="Caption">Use a predefined qualifier where possible.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/207309517-48fa4064-48c5-4131-9759-ac1c4ff9ff87.png" role="presentation" alt="An input with the value 'type:' suggesting options: 'Issue' and 'Pull request'. The options are missing icons." width="456" />
    <Caption mdxType="Caption">Use a custom qualifier instead of a predefined one.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Formatting`}</h3>
    <p>{`Always list qualifiers in a readable way and don't include all their options by using descriptions.
We do this to ensure that qualifiers are easy to scan and have enough context.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/980622/207311524-8ccb8373-b77d-424f-992f-d4d7c80860aa.png" role="presentation" width="456" alt="An empty filter input showing initial suggestions: 'Assignee', 'Is', 'Repository', 'State' and 'Total comments'" />
    <Caption mdxType="Caption">List qualifiers in a readable way and without their options.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/980622/207311528-dbe0c3d2-bb3a-4d7d-a115-8d285aa9697a.png" role="presentation" width="456" alt="An empty filter input showing initial suggestions with all the possible combinations: 'assignee: username, username', 'is: pr, issue, project', 'repo: github/github, github/primer', 'state: open, closed, draft', 'comments: >400, 100...200'" />
    <Caption mdxType="Caption">Don't list qualifiers as their raw value with possible options.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Dynamic values`}</h3>
    <p>{`Sometimes static values can be limiting when filtering results. For example, let's say you want to get all items created in the past 7 days. Using a static value, you would have to create a range of dates manually, such as `}<inlineCode parentName="p">{`2022-01-01..2023-01-07`}</inlineCode>{`. However, when you come back the next day (the 8th of January), you would have to update this range manually again to `}<inlineCode parentName="p">{`2022-01-02..2023-01-08`}</inlineCode>{`. This is not very convenient. That's why dynamic values can be useful in these situations. Using the same example, if you use the dynamic value `}<inlineCode parentName="p">{`@today-7d`}</inlineCode>{`, you will get all items created in the past 7 days. When you come back the next day, the range of dates will automatically update to reflect the current date, so you don't have to do it manually.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Translation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`@today`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Current date (excludes time)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`@me`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Current signed in user`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`⚠️ At the moment, we are conducting a review of dynamic values with multiple stakeholders, so changes may be made.`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`Filter inputs can have 3 different sizes:`}</p>
    <img src="https://user-images.githubusercontent.com/980622/204341476-89ad64b4-3232-42dd-894a-003877738cb7.png" role="presentation" alt="The filter input in three different sizes. The heights are as following: 28px, 32px and 40px." width="960" />
    <ul>
      <li parentName="ul">{`Small (`}<inlineCode parentName="li">{`28px`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`Medium (`}<inlineCode parentName="li">{`32px`}</inlineCode>{`) (default)`}</li>
      <li parentName="ul">{`Large (`}<inlineCode parentName="li">{`40px`}</inlineCode>{`)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      